/**
 * Copyright 2026 Salesforce, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import type { ReactElement } from 'react';
import Badge from '@/components/badge';
import { ShoppingCart } from 'lucide-react';

export default function CartBadgeIcon({ numberOfItems }: { numberOfItems: number }): ReactElement {
    return (
        <>
            <ShoppingCart className="size-5" data-testid="shopping-cart-icon" />
            {numberOfItems > 0 && (
                <Badge
                    variant="primary"
                    shape="number"
                    className="absolute -top-1 -right-1"
                    data-testid="shopping-cart-badge">
                    {numberOfItems}
                </Badge>
            )}
        </>
    );
}
